function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11 19.425v-6.85L5 9.1v6.85l6 3.475zm2 0l6-3.475V9.1l-6 3.475v6.85zm-1-8.575l5.925-3.425L12 4 6.075 7.425 12 10.85zM4 17.7a1.948 1.948 0 01-1-1.725v-7.95A1.948 1.948 0 014 6.3l7-4.025c.317-.183.65-.275 1-.275s.683.092 1 .275L20 6.3a1.948 1.948 0 011 1.725v7.95a1.948 1.948 0 01-1 1.725l-7 4.025c-.317.183-.65.275-1 .275s-.683-.092-1-.275L4 17.7z"
})));